import React from "react";

import "./AvailableFunds.scss";
import InfoBubble from "Components/InfoBubble";
import { Box } from "@mui/material";

const AvailableFundsBase = ({
  availableFunds,
  limitAmount,
  headerText,
  tooltipText,
  deposit,
  widthdraw,
}) => {
  const formattedAvailableFunds = availableFunds?.toLocaleString();
  const dollars = formattedAvailableFunds?.split(".")[0];
  const cents = formattedAvailableFunds?.split(".")[1];

  const limitDiv = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "row",
        gap: "12px",
      }}
    >
      <Box
        data-testid="deposit-limit-amount"
        sx={{
          color: "var(--color-text-alternate)",
          fontFamily: "var(--caption-font-family)",
          fontSize: "var(--caption-size-medium)",
          fontWeight: 400,
        }}
      >
        ${limitAmount || "0"} deposit limit
      </Box>
      <InfoBubble message={tooltipText} title="Available Funds Tooltip" />
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: { xs: "flex-start", md: "center" },
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: { xs: "flex-start", md: "center" },
          flexDirection: "column",
          gap: "var(--spacing-md)",
        }}
      >
        {headerText && (
          <Box className={deposit || widthdraw ? "sub-title" : "header"}>
            {headerText}
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
          className="header"
        >
          <Box>$</Box>
          <Box
            data-testid="transaction-amount-dollars"
            sx={{
              fontSize: "64px",
              lineHeight: 1,
            }}
          >
            {dollars || 0}
          </Box>
          <Box data-testid="transaction-amount-cents">
            {cents ? cents.padEnd(2, "0") : "00"}
          </Box>
        </Box>
        {limitAmount && limitDiv}
      </Box>
    </Box>
  );
};

export default AvailableFundsBase;
